//import axios from 'axios'
import {MessageBox} from 'element-ui'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: 10000, // request timeout
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    "X-Requested-With":"XMLHttpRequest"
  },
  withCredentials: true, // 允许携带cookie
  transformRequest: [
    data => {
      let ret = ''
      for (const it in data) {
        if (data[it] === undefined) {
          ret += encodeURIComponent(it) + '=&'
        } else {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
      }
      return ret
    }
  ]
})


let num=0
// response interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    if(res.s==2&&num==0){
      num++
      MessageBox.alert('登录超时，请重新登录','消息提示',{
        confirmButtonText: '确定',
        center: true,
        callback: action => {
          window.location.href=window.location.origin
          num=0
        }
      })
    }
    
    return res
    // if (res.s !== 1) {
    //   return Promise.reject(res.d || '数据请求失败，请稍后重试！')
    // } else {
    //   return res
    // }
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service
